import { useMemo } from 'react';

import type {
  CustomAttributesReadOnly,
  CustomAttributeType,
} from 'hb-react/frontoffice/apps/Mentoring/types';
import type { CustomAttributesForm } from 'hb-react/types';

export const useHydrateCustomAttributes = (
  customAttributesSchema: CustomAttributesReadOnly | CustomAttributeType[],
  attributes: CustomAttributesForm[],
) =>
  useMemo(
    () =>
      customAttributesSchema.map((attribute) => {
        const profileAttribute = attributes.find(
          (profileAttribute) =>
            profileAttribute.customizable_attribute_id === attribute.id,
        );

        return {
          ...attribute,
          ...profileAttribute,
          display_value: profileAttribute?.display_value ?? '-',
        };
      }),
    [customAttributesSchema, attributes],
  );
